import * as React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import AdminView from './components/AdminView'
import AnalystView from './components/AnalystView'
import { Card, CardBody } from 'reactstrap'

const Overview = ({ user }) => {
    const roles = user?.roles || []

    return (
        <Card>
            <CardBody> 
                {roles.includes('ROLE_ANALYST_ADMIN') ? (
                    <AdminView />
                ) : (
                    <AnalystView />
                )}
            </CardBody>
        </Card>
    )
}

const mapStatetoProps = (state) => {
    return {
        user: state.Login.user
    }
}

export default withRouter(connect(mapStatetoProps, {})(Overview))
